import React from "react"
import { Link } from "react-router-dom"

import { GoArrowUpRight } from "react-icons/go"

import Typewriter from "typewriter-effect"

export default function Hero() {
  return (
    <div className=" md:pt-[4vw] px-[5vw] text-center relative">
      <img
        src="/images/star.webp"
        alt=""
        className="w-[5vw] absolute top-[15vw] right-[10vw] fade-in-out"
      />
      <img
        src="/images/star.webp"
        alt=""
        className="w-[5vw] absolute top-[10vw] left-[10vw] fade-in-out"
      />
      <p className="text-[#FFFFFFA6] md:text-[6vw] text-[5vw] font-extralight text-center animate__shakeY wow animate__animated ">
        Bringing On-Chain{" "}
      </p>
      <h1 className="text-white md:text-[6vw] text-[5vw] font-semibold md:-translate-y-5 -translate-y-2  text-center ">
        <Typewriter
          options={{
            strings: ["Interactions to Twitter"],
            autoStart: true,
            loop: true,
          }}
        />
      </h1>
      <Link
        to={""}
        className="buy_now px-[4vw] py-[1.5vw] md:text-[1.5vw] text-[2vw] rounded-full animate__bounceIn wow animate__animated block max-w-fit mx-auto"
      >
        Buy Now
      </Link>
      <div className="grid grid-cols-12 gap-[5vw] md:mt-[5vw]">
        <div className="col-span-3  space-y-[2vw]">
          <img
            src="/images/hero-1.webp"
            alt="hero-1"
            className="w-[20vw] bounce"
          />
          <p className="text-start md:text-[1.1vw] text-[1.7vw] animate__fadeInUp wow animate__animated">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt .
          </p>
          <Link
            to={""}
            className="animate__fadeInUp wow animate__animated md:text-[1.5vw] text-nowrap text-[1.8vw] w-full py-[1vw] border-b border-white text-start flex items-center gap-2 max-w-fit"
          >
            Lorem Ipsum dolor
            <GoArrowUpRight className="md:text-[1.5vw] text-[2vw]" />
          </Link>
        </div>
        <div className="md:col-span-7 col-span-6 relative">
          <img
            src="/images/hero-3.webp"
            alt="hero-3"
            className="md:w-[20vw] w-[15vw] absolute md:right-[3vw] -right-[3vw] md:-top-[5vw] animate__fadeInUp wow animate__animated "
          />
          <img
            src="/images/hero-2.webp"
            alt="hero-2"
            className="md:w-[35vw] w-[45vw] mt-[5vw] bounce"
          />
        </div>
        <div className="md:col-span-2 col-span-3  text-start space-y-[2vw]">
          <div>
            <h3 className="text-[3vw] font-semibold animate__fadeInUp wow animate__animated">
              78K <span className="text-[#1D9BF0]">+</span>
            </h3>
            <p className="animate__fadeInUp wow animate__animated">
              {" "}
              Lorem ipsum dolor
            </p>
          </div>
          <hr />
          <div>
            <h3 className="text-[3vw] font-semibold animate__fadeInUp wow animate__animated">
              27K <span className="text-[#1D9BF0]">+</span>
            </h3>
            <p className="animate__fadeInUp wow animate__animated">
              {" "}
              Lorem ipsum dolor
            </p>
          </div>
          <hr />
          <div>
            <h3 className="text-[3vw] font-semibold animate__fadeInUp wow animate__animated">
              44K <span className="text-[#1D9BF0]">+</span>
            </h3>
            <p className="animate__fadeInUp wow animate__animated">
              {" "}
              Lorem ipsum dolor
            </p>
          </div>
          <hr />
        </div>
      </div>
    </div>
  )
}
